import constantes from '@/utils/ConstantesGlobais';

export default {
    name: 'Autoupdate',
    methods: {
        autoUpdate: autoUpdate,
        clearAutoUpdate: clearAutoUpdate,
    },
    data () {
        return {
            intervalos: {},
        };
    },
    beforeDestroy () {
        this.clearAutoUpdate();
    },
};

/*
    Recebe uma função parametro, uma data no futuro e um intervalo de tempo
    verifica se o momento atual é maior que a data
    exeuta o metodo passando o parametro
    chama o metodo que valida o intervalo de re execução
*/

function autoUpdate (funcao, parametro, chave, atualizarquandoMaior, intevaloDeAtualizacao, removerCarregamento = false) {
    const store = require('@/store').default;
    clearInterval(this.intervalos[chave]);
    this.intervalos[chave] = setInterval(function () {
        if (atualizarquandoMaior && atualizarquandoMaior instanceof Date) {
            if (Date.now() >= atualizarquandoMaior) {
                if (removerCarregamento) {
                    store.commit('loading/startAutoUpdateLoading');
                    funcao(parametro);
                } else {
                    funcao(parametro);
                }
            }
        } else {
            if (removerCarregamento) {
                store.commit('loading/startAutoUpdateLoading');
                funcao(parametro);
            } else {
                funcao(parametro);
            }
        }
    }, defineData(intevaloDeAtualizacao));
}

function clearAutoUpdate () {
    for (let intervalo in this.intervalos) {
        clearInterval(this.intervalos[intervalo]);
    }
}

// Se a parametro não for uma data e não puder ser convertido para uma, retorna o equivalente a 1hr!
/**
 *
 * @param {*} data
 */
function defineData (data) {
    if (data instanceof Date) {
        return data.getTime();
    } else if (Number.isInteger(data) && data > 100) {
        return data;
    } else {
        return constantes.TEMPO_ATUALIZACAO_PRADAO;
    }
}
